import React, { useEffect, useState } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";
import JewelPawnRecoverPdf from "./jewelpawnRecoverPdf";
import API_DOMAIN from "../config/config";

const JewelPawnRecoverPreview = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  

  return (
    <div>
     
        <PDFViewer width="100%" height="1000">
          <JewelPawnRecoverPdf data={rowData} />
        </PDFViewer>
      
    </div>
  );
};

export default JewelPawnRecoverPreview;
